export enum EnumUpdateStatus {
    NOTUPDATED = 'NOTUPDATED',
    UPDATED = 'UPDATED',
    UPDATE = 'UPDATE',
    RELEASE = 'RELEASE',
    NOTERMINAL = 'NOTERMINAL',
    NOAPPLICATION = 'NOAPPLICATION',
    TOPVERSION = 'TOPVERSION',

}